import { isBrowserEnvironment } from './isBrowserEnvironment';

const GA_COOKIE_NAMES = [/^_ga/, /^_gid$/];

function isIpAddress(hostname) {
    return /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname) || hostname.includes(':');
}

export function getParentDomains(hostname) {
    if (isIpAddress(hostname)) {
        return [hostname];
    }

    const labels = hostname.split('.');
    if (labels.length < 3) {
        return [hostname];
    }
    return labels.slice(0, -1).map((_, index) => labels.slice(index).join('.'));
}

function getCurrentHostname() {
    return isBrowserEnvironment() ? window.location.hostname : '';
}

export function getAnalyticsCookieRules(hostname = getCurrentHostname()) {
    return getParentDomains(hostname).flatMap((domain) => (
        GA_COOKIE_NAMES.map((name) => ({ name, domain }))
    ));
}
